
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import ALoader from '@/components/ALoader.vue'
import PostSingle from '@/components/Post/PostSingle.vue'
import useSuperLikeManager from '@/composables/post-super-like/superLikeManager'

export default defineComponent({
  name: 'SuperLikeList',
  components: { PostSingle, ALoader, AButton },
  async setup() {
    const {
      superLikedPostList,
      remaining,
      loading,
      loadNext,
      clear,
      hasNext,
    } = useSuperLikeManager()

    clear()
    await loadNext()

    return {
      superLikedPostList,
      remaining,
      loading,
      hasNext,
      loadNext,
    }
  },
})
